import Heading from "components/Heading/Heading";
import { Button, Form, Modal, message } from "antd";
import { useState } from "react";
import DataTable from "../../../components/Tables/DataTable";
import FormModal from "./FormModal";
import dayjs from "dayjs";
import { useGetBranchesQuery } from "../../../redux/Service/branches";
import { useGetCostCentersQuery } from "../../../redux/Service/costCenter";

import {
  useAddTransferMutation,
  useDeleteTransferMutation,
  useEditTransferMutation,
  useGetTransfersQuery,
  useLazyGetTransferByTransDocQuery,
} from "../../../redux/Service/transferApi";

function TransferStores() {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [subData, setSubData] = useState<any>([]);

  const {
    data: transfersData,
    isLoading,
    isError,
  } = useGetTransfersQuery(undefined);

  const transfers = transfersData?.ResponseObject ?? [];

  const {
    data: branchesData,
    isLoading: isBranchesLoading,
    isError: isBranchesError,
  } = useGetBranchesQuery(undefined);

  const branches = branchesData?.ResponseObject ?? [];

  const {
    data: costCentersData,
    isLoading: iscostCentersLoading,
    isError: iscostCentersError,
  } = useGetCostCentersQuery(undefined);

  const costCenters = costCentersData?.ResponseObject ?? [];

  const [triggerGetTransfer, { data, error, isLoading: isLoadingEdafaSarf }] =
    useLazyGetTransferByTransDocQuery();

  const [deleteRestriction, { isLoading: isDeleting }] =
    useDeleteTransferMutation();

  const [addRestriction, { isLoading: isAdding }] = useAddTransferMutation();

  const [updateRestriction, { isLoading: isUpdating }] =
    useEditTransferMutation();

  const handleDeletClick = (record: any) => {
    console.log(record);

    Modal.confirm({
      title: "تأكيد الحذف",
      content: `هل أنت متأكد أنك تريد حذف الحركة "${record.DocID}"؟`,
      okText: "حذف",
      okType: "danger",
      cancelText: "إلغاء",
      onOk: async () => {
        try {
          const response = await deleteRestriction(record.DocID).unwrap();

          if (response?.ResponseObject == true) {
            message.success("تم حذف الحركة بنجاح");
          } else {
            message.error("حدث خطأ أثناء الحذف");
          }
        } catch (error) {
          message.error("فشل الاتصال بالخادم");
        }
      },
    });
  };

  const columns: any = [
    {
      title: "كود الحركة",
      dataIndex: "TransDoc",
      key: "TransDoc",
    },
    {
      title: "تاريخ الحركة",
      dataIndex: "DocDate",
      key: "DocDate",
      width: 180,
    },

    {
      title: "الفرع",
      dataIndex: "SideName",
      key: "SideName",
      render: (_: any, record: any) => {
        return branches?.find((b) => b.BranchID == record.BranchId)?.BranchName;
      },
    },

    {
      title: "من المخزن",
      dataIndex: "StoreName",
      key: "StoreName",
    },
    {
      title: "الي المخزن",
      dataIndex: "ToStoreName",
      key: "ToStoreName",
    },
    {
      title: "ملاحظات",
      dataIndex: "Notes",
      key: "Notes",
      width: 200,
    },
  ];

  const handleOk = async (values) => {
    const body = {
      ...values,
      TransFormItems: subData,
      DocDate: values.DocDate?.format("YYYY-MM-DD"),
    };
    console.log("body", body);

    // return;

    try {
      let response;

      if (isEditing) {
        response = await updateRestriction(body).unwrap(); // طلب التحديث
      } else {
        response = await addRestriction(body).unwrap(); // طلب الإضافة
      }

      if (response?.ResponseObject == true) {
        message.success(
          isEditing ? "تم تعديل الحركة بنجاح" : "تمت إضافة الحركة بنجاح"
        );
        setIsModalOpen(false);
        resetModal();
      } else {
        message.error("حدث خطأ أثناء العملية");
      }
    } catch (error) {
      message.error("فشل الاتصال بالخادم");
    }
  };

  function resetModal() {
    form.resetFields();
    setIsEditing(false);
    setSubData([]);
  }

  const handleCancel = () => {
    setIsModalOpen(false);
    resetModal();
  };

  const handleEditClick = async (record: any) => {
    setIsEditing(true);
    setIsModalOpen(true);

    console.log("record", record);

    try {
      const res = await triggerGetTransfer(record.TransDoc).unwrap();

      console.log("res", res);

      if (res.ResponseObject) {
        const rawData = res.ResponseObject[0];

        // ✅ إنشاء نسخة قابلة للتعديل
        const recordData = { ...rawData };

        console.log("recordData", recordData);
        setSubData(recordData.TransFormItems || []);

        if (recordData.DocDate) {
          recordData.DocDate = dayjs(recordData.DocDate);
        }

        setTimeout(() => {
          form.setFieldsValue(recordData);
        }, 0);
      } else {
        message.error("حدث خطأ أثناء جلب البيانات");
      }
    } catch (error) {
      console.error("error", error);
      message.error("فشل في جلب البيانات من السيرفر");
    }
  };

  return (
    <>
      <Heading name={"تحويل بين المخازن"} />
      <div className="flex flex-wrap gap-4 relative">
        <div className="grid justify-start">
          <Button type="primary" onClick={() => setIsModalOpen(true)}>
            إضافه
          </Button>
        </div>

        <FormModal
          form={form}
          isEditing={isEditing}
          isModalOpen={isModalOpen}
          handleOk={handleOk}
          handleCancel={handleCancel}
          initialValues={{ FirstBal: 0, DocDate: dayjs(new Date()) }}
          loading={isUpdating || isAdding}
          subData={subData}
          setSubData={setSubData}
          branches={branches}
          costCenters={costCenters}
        />

        <DataTable
          columns={columns}
          data={transfers}
          handleEditClick={handleEditClick}
          handleDeletClick={handleDeletClick}
          isLoading={isLoading || isDeleting}
        />
      </div>
    </>
  );
}

export default TransferStores;
